import { createApiClient, type ApiClient } from '@dss/api-client'

/** Singleton API-клиент для admin app.
 *  baseUrl читаем из VITE_API_BASE_URL (см. .env.example). */
const baseUrl = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8081/api'

export const api: ApiClient = createApiClient({ baseUrl })
